<template>
  <main class="terms">
    <ContentsHeader />
    <article class="main_content">
      <div class="pankuzu">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a :href="topurl()">トップ</a></li>
          <li class="breadcrumb-item active">プライバシーポリシー</li>
        </ol>
      </div>

      <div class="privacy_list__wrapper">
        <section class="top_link_list">
          <h1 class="page-title">FitGapプライバシーポリシー</h1>
          <div class="page-body">
            <p id="3a8ab4b3-fdac-400a-88e5-f7c9c928aae6" class="">
              株式会社PIGNUS（以下、「当社」という。）は、個人情報保護を当社の重要な責務と認識し、当社が提供する「FitGap」に関するサービス（以下、「本サービス」という。）を利用（資料請求等をする場合だけでなく、閲覧のみをする場合も含みます。）される皆様（以下、「利用者」という。）の個人情報の取り扱いについて、当社が定める「FitGapプライバシーポリシー」（以下、「本プライバシーポリシー」という。）に則り、その利用や取り扱いには細心の注意を払います。
            </p>
            <h2 id="225f9dab-71f4-40c8-8388-3a4214f330d5" class="">1. 個人情報の利用等について</h2>
            <h3 id="c363df0a-28cd-4be6-acaf-2d2b709fa5c6" class="">■個人情報とは</h3>
            <p id="e94566a4-16de-481b-a449-6179a0d5cb6c" class="">
              本プライバシーポリシーにおいて「個人情報」とは、個人情報保護法における「個人情報」を意味し、具体的には氏名、住所、電話番号、メールアドレス等利用者個人を識別できる情報（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。）を指します。
            </p>
            <h3 id="5e7e63af-244f-47f8-8d57-310adcace960" class="">■取得する個人情報</h3>
            <p id="7a8444f1-0a3b-4d1b-baa0-111ff8c7c1a2" class="">
              本サービスにおいては、例えば以下のような個人情報を取得します。本サービスでは、利用者登録等において利用者が個人情報を自ら提供した場合又は提供することを了承した場合にのみ個人情報を取得します。</p>
            <ol type="1" id="9521ce32-e908-4d25-9ab0-ba3dd3f9e56d" class="numbered-list" start="1">
              <li>氏名</li>
            </ol>
            <ol type="1" id="c76c12f9-e0fd-46f7-9883-404f61fc21ac" class="numbered-list" start="2">
              <li>住所（勤務先の住所を含みます。）</li>
            </ol>
            <ol type="1" id="85a0a704-d91f-46e6-a915-5ccde5075798" class="numbered-list" start="3">
              <li>連絡先（電話番号、メールアドレス等）</li>
            </ol>
            <ol type="1" id="9271daee-60c4-481e-bd15-701380a9afa1" class="numbered-list" start="4">
              <li>会社名、役職等の勤務先に関する情報</li>
            </ol>
            <ol type="1" id="304b0593-6759-4017-955c-70201fdbab39" class="numbered-list" start="5">
              <li>SNSアカウント（Facebook,Linkedin,Twitter等）の情報</li>
            </ol>
            <h3 id="fbc4a467-8498-4131-a29a-b52bf84214a6" class="">■個人情報の利用目的</h3>
            <p id="253cec6d-c4f3-430d-b9fa-029e6fcb0549" class="">
              利用者の個人情報は、以下の目的のために利用します。当社は、利用者本人の同意がある場合を除き、以下の利用目的の範囲を超えて、取得した個人情報を利用しません。</p>
            <ol type="1" id="5a1a8e64-7d94-4045-89a0-0a6b65e62599" class="numbered-list" start="1">
              <li>本サービスへの登録、利用者の管理等本サービスの提供及び運営のため</li>
            </ol>
            <ol type="1" id="0549940f-a891-44b4-9091-095cbe462254" class="numbered-list" start="2">
              <li>本サービスの保守・管理のため</li>
            </ol>
            <ol type="1" id="1a157f22-5210-498c-9c8e-648e0f53b8af" class="numbered-list" start="3">
              <li>当社が利用者からのお問い合わせに返答するため及び利用者に連絡するため</li>
            </ol>
            <ol type="1" id="336566e7-6726-45bb-93ce-4fea5fed0b6b" class="numbered-list" start="4">
              <li>利用者の属性、行動履歴の分析や興味及び関心の分析のため</li>
            </ol>
            <ol type="1" id="e489672b-7dc1-491b-867a-15a633de490d" class="numbered-list" start="5">
              <li>利用者の属性の集計、分析を行い、個人が識別・特定できないように加工した統計データ、統計資料等（以下、「統計資料」という。）を作成、利用するため</li>
            </ol>
            <ol type="1" id="3ac9f7c8-93b9-4b0d-a24e-258f13ea3781" class="numbered-list" start="6">
              <li>不正利用防止又は対応のため</li>
            </ol>
            <ol type="1" id="0e40b701-a3a4-47dd-955c-ad85cf634ca1" class="numbered-list" start="7">
              <li>本サービスを含む当社サービスの改善、向上のため及び新しいサービスの企画、開発、研究のため</li>
            </ol>
            <ol type="1" id="959c39b4-fe96-463a-868a-da13e2b8d275" class="numbered-list" start="8">
              <li>キャンペーン、懸賞企画、アンケートの実施のため</li>
            </ol>
            <ol type="1" id="0351cf01-be7c-47cb-a29f-f06ce0c3169f" class="numbered-list" start="9">
              <li>当社のサービス又は第三者が提供するサービスのご案内をするため</li>
            </ol>
            <ol type="1" id="432ed65d-1376-4a92-b6ed-d74e5f046f96" class="numbered-list" start="10">
              <li>本プライバシーポリシーに従った第三者に対する提供のため</li>
            </ol>
            <h3 id="79cdbb13-a2ed-4099-9935-5a023dbaf322" class="">■個人情報の第三者への提供</h3>
            <ol type="1" id="a8e3a1d1-625d-4364-9a7a-e42280816d7d" class="numbered-list" start="1">
              <li>当社は以下の場合、利用者の個人情報を第三者に提供します。</li>
            </ol>
            <ol type="1" id="5d18ea59-4dcd-49ad-9772-fb2f4203a3dc" class="numbered-list" start="2">
              <li>利用者が本サービスを通じて、第三者の提供するサービスに関する資料請求、お問い合わせ等を行った場合（ただし、提供する相手は当該サービスを提供する第三者（その委託先を含みます。）に限ります。）</li>
            </ol>
            <ol type="1" id="6f30b4db-9bf1-446a-a036-76189c7dac72" class="numbered-list" start="3">
              <li>利用者が同意を与えた場合</li>
            </ol>
            <ol type="1" id="0ab674a9-0454-42bb-abaf-0c4be6687210" class="numbered-list" start="4">
              <li>法令に基づく場合</li>
            </ol>
            <ol type="1" id="57d95e04-4899-49ce-a368-04b6f9002011" class="numbered-list" start="5">
              <li>人の生命、身体又は財産の保護のために必要がある場合であって、利用者の同意を得ることが困難であるとき</li>
            </ol>
            <ol type="1" id="d04a4a2b-11e6-41f0-a636-c2913b3eb68a" class="numbered-list" start="6">
              <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、利用者の同意を得ることが困難であるとき</li>
            </ol>
            <ol type="1" id="9b4dfd24-6455-4029-ae43-0eecaf1533f0" class="numbered-list" start="7">
              <li>国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用者の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
              </li>
            </ol>
            <ol type="1" id="9e9b89e7-ae22-46fd-9ad7-1725f15ede34" class="numbered-list" start="8">
              <li>その他法令で認められる場合</li>
            </ol>
            <ol type="1" id="49daa392-0fa3-4ba6-8baf-30198d74716b" class="numbered-list" start="9">
              <li>上記に関わらず、当社は、上記利用目的に従い作成した統計資料を、当社の業務提携先等に提供することがあります。統計資料には、個人を識別・特定できる情報は一切含みません。</li>
            </ol>
            <h2 id="e8a7e462-b1e8-4ddb-9267-70474e33af49" class="">2.個人情報の管理について</h2>
            <h3 id="7327252a-70d8-4b72-85a7-53a1d6f379fc" class="">■安全管理措置</h3>
            <p id="99bace8f-5c16-42f6-92cc-d3d297699956" class="">
              当社は、個人情報の漏洩、滅失又は毀損の防止、その他個人情報の安全管理のために必要な措置を講じます。当社の安全管理措置については、下記「お問い合わせ窓口」までお問い合わせください。</p>
            <h3 id="0aee3398-4272-489a-be6c-43f97774e8b3" class="">■開示請求等</h3>
            <ol type="1" id="97a3019c-e0ab-4477-af3c-753a476eefb0" class="numbered-list" start="1">
              <li>
                利用者は、いつでも本サービスに登録している利用者情報を、本サービス上で確認、訂正することができます。また、利用者は、当社に対し、個人情報の開示等（個人情報保護法において認められる範囲内の利用目的の通知、個人情報又は第三者提供記録の開示、訂正・追加・削除、利用の停止・第三者提供の停止の請求を意味します。）を求めることができます。ただし、以下の各号のいずれかに該当する場合には、当社は、開示を行わないことがあります。
              </li>
            </ol>
            <ol type="1" id="0a786494-0095-4031-895b-1505423e82c5" class="numbered-list" start="2">
              <li>開示することで本人又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
            </ol>
            <ol type="1" id="841ac221-06b1-40ac-94d5-9f5d665ef370" class="numbered-list" start="3">
              <li>開示することで当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
            </ol>
            <ol type="1" id="c344d740-c0f6-43ed-91f6-20e650794af8" class="numbered-list" start="4">
              <li>開示することが法令に違反することとなる場合</li>
            </ol>
            <ol type="1" id="d3af48e9-d926-4efd-997f-18b93bd7a6c3" class="numbered-list" start="5">
              <li>開示の請求がご本人からであることが確認できない場合</li>
            </ol>
            <ol type="1" id="cd1525bf-069c-4fc0-998d-9d0bf93733d4" class="numbered-list" start="6">
              <li>
                個人情報の訂正・追加・削除については、請求があった場合、当社は、利用目的の達成に必要な範囲内で遅滞なく調査を行い、その結果に基づいて、個人情報保護法において認められる範囲内において当該個人情報の訂正・追加・削除を行います。なお、当該手続きは、別途当社が定める手続きに従うものとし、別途当社が定める手数料が発生する場合があります。当該手続きを希望する場合は、以下の「4.
                その他」に記載の「お問い合わせ窓口」までご連絡ください。</li>
            </ol>
            <h2 id="af2fae39-179a-4e53-a069-8e826ec48969" class="">3. 個人情報以外の利用者の情報</h2>
            <h3 id="614f9ae1-0d39-47d0-93c2-ffc058a3d5bf" class="">■当社が取得する個人情報以外の利用者の情報</h3>
            <p id="e185e0f1-5361-4028-84a6-a67a5a3056ce" class="">
              当社は、個人情報のほかに、例えば、以下のような利用者に関係する情報を取得します。なお、これらの情報が個人情報に該当する場合には、これらの情報であっても個人情報として取り扱います。</p>
            <ol type="1" id="5fcb3e80-0337-4085-9b3a-36dcc70d6dad" class="numbered-list" start="1">
              <li>利用者が本サービスの利用に際して入力、送信した個人情報以外の利用者に関する情報</li>
            </ol>
            <ol type="1" id="ace65e39-f7f1-4148-9c31-340f11b69981" class="numbered-list" start="2">
              <li>本サービスの利用日時及び回数、本サービス利用時のユーザーのオンライン行動等、ユーザーによる本サービスの利用・閲覧に関連する情報（これには、Cookie
                情報、アクセスログ等の利用状況に関する情報、利用端末の情報、OS情報、IPアドレス、ブラウザ情報、ブラウザ言語等を含む利用者の通信に関する情報を含みます。）</li>
            </ol>
            <ol type="1" id="2ac4abb9-0f74-479e-9ac5-471b853b88eb" class="numbered-list" start="3">
              <li>利用者によるアンケートの回答結果</li>
            </ol>
            <h3 id="28e0bb2a-a028-4c0c-983f-7a49d166ec00" class="">■個人情報以外の利用者の情報の利用</h3>
            <p id="68f9ff42-525a-4fb7-8df1-9a65b573fb2b" class="">
              当社は、個人情報以外の利用者の情報について、「個人情報の利用目的」に準じて利用します。なお、個人情報以外の利用者の情報の第三者提供については、個人情報保護法における個人関連情報の規制に該当する場合、これに従います。
            </p>
            <p id="02ccfd3a-410e-498b-812d-da10a506278e" class="">
              なお、Cookieに関して、当社は、上記利用目的のため、Cookieを利用者のコンピュータに保存し、参照することがあります。加えて、当社は、本サービス内で広告を配信する場合があり、当該広告配信を行う会社（第三者）が、利用者のコンピュータ内にクッキーを保存し参照することがあり、第三者によるCookieの利用はその第三者のプライバシーポリシーに従って行われます。なお、第三者が、本サービス又は当社が保有するCookieを参照することはできません。
            </p>
            <h2 id="056c88cf-2686-499a-8243-690d31319db6" class="">4. その他</h2>
            <h3 id="32a7df6c-bc56-4c59-aa54-561c3c19fd1f" class="">■お問い合わせ窓口</h3>
            <p id="1cb98c78-14cf-45d6-92ea-cecc6913cec2" class="">ご意見、ご質問、苦情、その他個人情報の取り扱いに関するお問い合わせは、以下の窓口までご連絡ください。</p>
            <p id="319b6687-1260-4ea2-a17a-de5858510734" class="">FitGap事業部</p>
            <p id="ce7d2262-b342-4ed4-b1e9-7f7c4a20c61b" class="">住所：東京都港区六本木1-4-5 アークヒルズサウスタワー4階</p>
            <p id="14848e5c-337a-4b35-b80c-60dfd0e38c4d" class="">電話番号：03-6804-3469（受付時間：10時～17時、土日祝除く。）</p>
            <p id="eb1495f4-9a13-4bcf-ab77-4b98f1f988d5" class="">e-mail：hello@fitgap.com</p>
            <h3 id="9d5381a9-4281-4ffe-84c7-89a250d91ce8" class="">■プライバシーポリシーの改訂について</h3>
            <p id="67202c9f-04c4-4c9b-b868-997cdcbb1d16" class="">
              当社は、プライバシーポリシーの全部又は一部を改訂することがあります。改訂する場合には、本サービス上又は当社のホームページ上等の適切な方法にてお知らせするとともに、改定内容に応じた必要な措置を行います。</p>
            <p id="f769ad66-94b0-4333-8020-7c8cba322013" class="">
            </p>
            <h2 id="2e206485-27f0-429c-aef5-36e9a7eef32e" class="">附則</h2>
            <p id="d86c0600-f164-4a84-be15-abe616fa591c" class="">2023年03月 制定・施行</p>
            <p id="d852ea3a-8819-4bbb-ae21-4466d8709f92" class="">以上</p>
          </div>
        </section>
      </div>
      <div class="border_divider"></div>
    </article>
    <div style="margin-bottom: 32px" v-if="pager.isDebug">
      <div>デバグ</div>
    </div>
    <ContentsFooter :pager="pager" />
  </main>
</template>

<style>
.privacy_list__wrapper .page-body h2 {
  margin-top: 24px;
}

.privacy_list__wrapper .page-body h3 {
  margin-top: 16px;
}

.privacy_list__wrapper .page-body p {
  padding-top: 8px;
}

.privacy_list__wrapper .page-title {
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0.75em;
}

.privacy_list__wrapper h1 {
  font-size: 1.875rem;
  margin-top: 1.875rem;
}
</style>

<style scoped>
.terms {
  min-height: 100vh;
  flex-flow: column;
  display: flex;
  background: #F9FBFB;
}

.main_content {
  flex: 1;
}

.privacy_list__wrapper {
  background: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.24);
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 8px;
  padding-right: 8px;
}

.privacy_maintitle {
  color: #444545;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 16px;
}

.privacy_list__date {
  color: #636464;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  margin-bottom: 4px;
}

.privacy_list__description {
  color: #444545;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  margin-bottom: 16px;
}

.privacy_list_session {
  border-top: 1px solid #EFF0F0;
  padding-top: 12px;
  padding-bottom: 8px;
}

.privacy_list_session__header {
  color: #444545;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 8px;
}

.privacy_list_session__body {
  color: #444545;
  font-weight: 400;
  font-size: 14px;
  line-height: 142%;
  margin-bottom: 8px;
}

.privacy_list_session__subheader {
  color: #444545;
  font-weight: 700;
  font-size: 14px;
  line-height: 142%;
  margin-top: 8px;
  margin-bottom: 8px;
}

.privacy_list_session__li ol {
  padding-inline-start: 16px;
}
</style>


<script>
// @ is an alias to /src

// eslint-disable-next-line
import tacklebox from "tacklebox";
import ContentsHeader from "@/components/ContentsHeader.vue";
import ContentsFooter from "@/components/ContentsFooter.vue";

import { PolicyPage } from "@/js/page/PolicyPage.js";

export default {
  name: "PolicyView",
  data() {
    return {
      page: new PolicyPage(),
      isNetworking: false,
      title: "",
    };
  },
  mounted() {
    this.title = this.$route.query.title;
    this.pager.changePage(this.page);

    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 " + this.title;
  },
  beforeUnmount() {
    //
  },
  methods: {
    lpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/search/" + id + "?title=" + title;
    },
    klpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/ksearch/" + id + "?title=" + title;
    },
    topurl() {
      return process.env.VUE_APP_SELF;
    },
    categoryurl() {
      return process.env.VUE_APP_SELF + "/#/category";
    },
    kwurl() {
      return process.env.VUE_APP_SELF + "/#/keyword";
    },
    gotoFreeword() {
      this.$router.push({ name: "freeword" });
    },
  },
  components: {
    ContentsFooter,
    ContentsHeader,
  },
  props: {
    pager: Object,
  },
};
</script>
